import React from 'react';
import PropTypes from 'prop-types';
import { useLinkScroll } from '@/hooks/useLinkScroll';

const PartnerTermsContent = ({ type, partners }) => {
  useLinkScroll('#scroll-link');

  return (
    <>
      {partners.map(
        ({ partner_name: partnerName, access_guests: accessGuests, terms }) => (
          <React.Fragment key={partnerName}>
            <h3 className="tw-text-xs tw-font-bold">{partnerName}</h3>
            <p
              className="margin-2-b tw-text-xs a-children_tw-underline focus_a-children_tw-text-blue-bright-600"
              dangerouslySetInnerHTML={{
                __html: type === 'access-guest' ? accessGuests : terms,
              }}
            />
          </React.Fragment>
        )
      )}
    </>
  );
};

PartnerTermsContent.propTypes = {
  type: PropTypes.oneOf(['access-guest', 'terms']).isRequired,
  partners: PropTypes.arrayOf(
    PropTypes.shape({
      partner_name: PropTypes.string,
      provider_id: PropTypes.string,
      logo: PropTypes.string,
      link_label: PropTypes.string,
      link_URL: PropTypes.string,
      terms: PropTypes.string,
      order: PropTypes.number,
    })
  ).isRequired,
};

export default PartnerTermsContent;
